module.exports = __webpack_public_path__ + "static/img/wechat_banner_bg.208bfeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/wechat_banner_bg.png
// module id = 62k7
// module chunks = 14